import NextHead from 'next/head'
import config from '../../../config.json'

export default function PageHead({
    title,
    description,
    og_title,
    og_description,
    og_url,
    og_type = 'website',
    canonical,
    og_image,
    extra
}) {
    if (typeof window !== 'undefined') {
        if (config?.integrations?.sanjagh?.push?.token)
            window.snj_notif = {
                publisher_id: config.integrations.sanjagh.push.token,
                delay: 5
            }
    }
    return (
        <NextHead>
            {title && <title>{title}</title>}
            {canonical && <link rel="canonical" href={canonical} />}
            {/* meta tags */}
            {description && (
                <meta
                    name="description"
                    content={description}
                />
            )}
            {og_title && (
                <meta property="og:title" content={og_title} key="og-title" />
            )}
            {og_description && (
                <meta
                    property="og:description"
                    content={og_description}
                    key="og-description"
                />
            )}
            {og_url && <meta property="og:url" content={og_url} key="og-url" />}
            {og_type && (
                <meta property="og:type" content={og_type} key="og-type" />
            )}
            {og_image && (
                <meta property="og:image" content={og_image} key="og-image" />
            )}
            {extra}
        </NextHead>
    )
}
